// extracted by mini-css-extract-plugin
export default {"container":"Oz_q4F","content":"JXt1SB","animate":"jQCLCQ","slider":"YFGEBU","item":"y9okKe","prev":"udpO6n","next":"mDTOVv"};